<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle">
		<div class="vstack gap-5">
			<div class="hstack gap-3 align-items-start" v-for="user in modelValue" v-bind:key="user.id">
				<div class="flex-fill w-75 pt-1">
					<div class="text-white-space" v-html="user.name"></div>
				</div>
				<div class="flex-fill vstack gap-3">
					<div class="input-group input-group-sm" v-for="(level, index) in levels" v-bind:key="index">
						<span class="input-group-text" v-tooltip:left="level.name">{{ index + 1 }}º</span>
						<VueNumberFormat
							v-model:value="user.pivot.thresholds[index]"
							class="form-control"
							placeholder="Comisión alcanzada"
							:options="{ precision: 2, acceptNegative: false }"
						></VueNumberFormat>
					</div>
				</div>
				<div>
					<button type="button" class="btn btn-sm btn-square btn-neutral" @click="remove(user.id)"><i class="bi bi-trash"></i></button>
				</div>
			</div>
			<a href="javascript:void(0);" class="link-primary" @click="modalUser.show()"><i class="bi bi-plus pe-1"></i>Agregar vendedor</a>
		</div>
	</LayoutFormInputGeneral>

	<CompanyAdminUserModalSelect ref="modalUser" title="Seleccionar vendedores" :filters="{ role: 'seller' }" :selecteds="selecteds" @select="add" />
</template>

<script>
	import { ref, computed } from 'vue';
	import { useToast } from 'vue-toastification';
	import _ from 'lodash';

	export default {
		props: {
			modelValue: Array,
			levels: Array,
			title: String,
			subtitle: String,
			placeholder: String
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
			const toast = useToast();
			const selecteds = computed(() => _.map(props.modelValue, 'id'));
			const modalUser = ref(null);

			const add = (data) => {
				if(_.some(props.modelValue, { id: data.id })) {
					toast.warning(`El vendedor ${data.name} ya se encontraba seleccionado.`);
					return;
				}

				data.pivot = { thresholds: props.levels.map(() => null) };
				props.modelValue.push(data);
			}

			const remove = (id) => {
				_.remove(props.modelValue, user => user.id === id);
			}

			return { inputId, selecteds, modalUser, add, remove };
		}
	}
</script>